// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class DefaultSettingsApi extends MainAPI {
	/**
	 * @return {object} default settings list
	 * @param {*} queryParams
	 */
	async getDefaultSettings(queryParams) {
		return API.get(`${ENDPOINTS.GET_DEFAULT_SETTINGS}?${queryString.stringify(queryParams)}`);
	}
}

export default new DefaultSettingsApi();